/**
 * Предзагружает флаги фич до монтирования приложения — страница логина
 * должна знать их уже на первом рендере. Эндпоинт публичный, токен не нужен.
 *
 * Сам запрос стартует при создании стора (useQuery с immediate watch),
 * refresh() возвращает тот же pending-промис, поэтому запрос ровно один.
 * Ошибку colada складывает в query.error, промис не реджектится — падение
 * сети не сломает bootstrap приложения.
 */
export default defineNuxtPlugin(async () => {
  const { refresh } = useFeatureStore()
  await refresh()
})
